export default function Thinking() {
  return (
    <main className="page">
      <header className="thinking__hero">
        <h1>Thinking</h1>
        <p>
          Writing that reflects how I approach product, AI, and the work of
          building things people actually trust.
        </p>
      </header>

      <section className="essay-placeholder">
        <div className="essay-card">
          <span className="essay-card__eyebrow">Essay · In progress</span>
          <h2 className="essay-card__title">
            Why Enterprise AI Fails at Trust — and What Actually Fixes It
          </h2>
          <p className="essay-card__excerpt">
            Enterprise AI adoption isn't stalling because the technology isn't ready.
            It's stalling because companies keep trying to solve a trust problem with
            a features argument. Trust isn't built by capability lists or responsible
            AI statements. It's built by making AI legible, controllable, and proven
            in context — and that's a product problem.
          </p>
          <span className="essay-card__status">Coming soon</span>
        </div>
      </section>

      <div className="contact-strip">
        <div>
          <h2>Let's talk.</h2>
          <p>Currently exploring VP, Head of Product, and Senior Director opportunities where AI is core to the product.</p>
        </div>
        <a href="mailto:simoneaehrlich@gmail.com" className="btn">simoneaehrlich@gmail.com</a>
      </div>
    </main>
  );
}
